/*------------------------------------*\
    giftcard select
\*------------------------------------*/
module.exports = function(){

    if ($('[js-giftcard-select]').length) {

        $('[js-giftcard-select]').on('change',function(event) {
            event.preventDefault();

            var title = $(this).find('option:selected').text();
            var id = $(this).val();

            $('[js-productpage-product-title]').text(title);

            document.title = title + ' | Product | Eph Apparel';

            $('.js-wishlist-add').attr('data-prod-id', id);
            $('.js-cart-add').attr('data-prod-id', id);




            var titleToCompare = title.replace(/\s/g, '');
            var titleToCompare = titleToCompare.toLowerCase();

            console.log(titleToCompare);

            var priceEl = $('[js-productpage-price]');

            if (titleToCompare=='$25giftcard') {
                priceEl.text('$25');
            }
            if (titleToCompare=='$50giftcard') {
                priceEl.text('$50');
            }
            if (titleToCompare=='$100giftcard') {
                priceEl.text('$100');
            }
            if (titleToCompare=='$200giftcard') {
                priceEl.text('$200');
            }
            if (titleToCompare=='$300giftcard') {
                priceEl.text('$300');
            }
            if (titleToCompare=='$400giftcard') {
                priceEl.text('$400');
            }
            if (titleToCompare=='$500giftcard') {
                priceEl.text('$500');
            };

        });
    }



}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/giftcard_select.js